// components/helpers/CardGroupsMobile.jsx
import React, { useState } from "react";
import ModalDialog from "../ModalDialog";
import "../../css/card-creator.css";

const CardGroupTabs = ({
                              groups,
                              cards,
                              setNewGroupData,
                              activateCreationModal,
                              setButtonText,
                              changeGroupStatus,
                              setProcessing,
                              unbindGroup,
                              deleteGroup,
                          }) => {
    const [activeModalQr, setActiveModalQr] = useState("no");
    const [activeUnbindModal, setActiveUnbindModal] = useState("no");
    const [qrData, setQrData] = useState("");
    const [qrName, setQrName] = useState("");
    const [groupToAction, setGroupToAction] = useState();
    const [groupAction, setGroupAction] = useState();
    const [modalMessage, setModalMessage] = useState("");

    if (!groups?.length) {
        return <h3 style={{ padding: "0 15px" }}>У вас пока нет групп реквизитов</h3>;
    }

    return (
        <div className="mobile-card-list">
            {groups.map((group, index) => {
                const isOnline = group.device?.online;
                const cardDetails = group.cards.map((id) => {
                    const card = cards.find((c) => String(c._id) === String(id));
                    return card
                        ? `${card.cardholder} [${card.bank}] [*${card.number.slice(-4)}]`
                        : id;
                });

                return (
                    <div
                        key={group._id}
                        className={`mobile-card-card ${group.active ? "active-card" : "inactive-card"}`}
                    >
                        <div className="card-header">
                            <strong className="cardholder-name">{group.name}</strong>
                            <span>{group.type === "farm" ? "Ферма" : "Мультипарсинг"}</span>
                        </div>

                        <div className="card-section">
                            <div>
                                <strong>Устройство:</strong>
                                <span>
                  {group.device
                      ? isOnline
                          ? <span className="green-bold">OnLine</span>
                          : <span className="red-bold">OffLine</span>
                      : <span className="red-bold">Не привязано</span>}
                </span>
                            </div>
                            <div>
                                <strong>Карты:</strong>
                                <div style={{
                                    fontSize: "12px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "2px",
                                    marginTop: "4px"
                                }}>
                                    {cardDetails.map((cardText, idx) => (
                                        <span key={idx}>{cardText}</span>
                                    ))}
                                </div>
                            </div>

                        </div>

                        {group.token && (
                            <div className="card-section">
                                <button
                                    className="gradient-orange-button mobile-card-btn"
                                    onClick={() => {
                                        setQrData(group.token.token);
                                        setQrName(`${group.name}\n${group.token.token}`);
                                        setActiveModalQr("progress");
                                        setTimeout(() => setActiveModalQr("active"), 100);
                                    }}
                                >
                                    Токен
                                </button>
                            </div>
                        )}

                        <div className="card-actions">
                            <button
                                className="gradient-orange-button mobile-card-btn"
                                onClick={() => {
                                    setButtonText("Сохранить");
                                    setNewGroupData(group);
                                    activateCreationModal();
                                }}
                            >
                                Изменить
                            </button>

                            {group.device && (
                                <>
                                    <button
                                        className={`${
                                            group.active
                                                ? "gradient-red-button"
                                                : "gradient-green-button"
                                        } mobile-card-btn`}
                                        onClick={() => {
                                            setProcessing({ now: true, button: "switch", index });
                                            changeGroupStatus(group._id, group.active);
                                        }}
                                    >
                                        {group.active ? "Отключить" : "Включить"}
                                    </button>

                                    <button
                                        className="gradient-orange-button mobile-card-btn"
                                        onClick={() => {
                                            setGroupAction("unbind");
                                            setModalMessage(`Вы действительно хотите отвязать группу ${group.name} от устройства?`);
                                            setGroupToAction(group._id);
                                            setActiveUnbindModal("progress");
                                            setTimeout(() => setActiveUnbindModal("active"), 100);
                                        }}
                                    >
                                        Отвязать
                                    </button>
                                </>
                            )}

                            <button
                                className="gradient-dark-button mobile-card-btn"
                                onClick={() => {
                                    setGroupAction("delete");
                                    setModalMessage(`Вы действительно хотите удалить группу ${group.name}?\nКарты при этом не удаляются`);
                                    setGroupToAction(group._id);
                                    setActiveUnbindModal("progress");
                                    setTimeout(() => setActiveUnbindModal("active"), 100);
                                }}
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                );
            })}

            <ModalDialog
                active={activeModalQr}
                setActive={setActiveModalQr}
                qrcode={qrData}
                message={qrName}
                purpose="info"
            />

            <ModalDialog
                active={activeUnbindModal}
                setActive={setActiveUnbindModal}
                message={modalMessage}
                purpose="choice"
                action={
                    groupAction === "unbind"
                        ? () => unbindGroup(groupToAction)
                        : groupAction === "delete"
                            ? () => deleteGroup(groupToAction)
                            : () => {}
                }
            />
        </div>
    );
};

export default CardGroupTabs;
